import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "semantic-ui-react";
import { yup } from "utils";

import Form from "components/Form";
import Modal from "components/Modal";

import { useUpdatePractice } from "./hooks";
import { AccountOwnerSelector } from "./components";

function EditPracticeModal({ practice, accountOwner, onSubmit, onClose }) {
  const { loading, updatePractice } = useUpdatePractice(() => {
    onSubmit();
    onClose();
  });

  const formProps = useForm({
    mode: "onBlur",
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("The practice name is required"),
      })
    ),
    defaultValues: { name: practice?.name },
  });

  return (
    <Modal
      isModalOpen
      size="mini"
      onClose={onClose}
      data-test="edit-practice-modal"
    >
      <Modal.Header onClose={onClose}>Edit Practice</Modal.Header>
      <Modal.Body>
        <Form
          id="editPractice"
          {...formProps}
          onSubmit={({ name, accountOwnerId }) => {
            return updatePractice(name, accountOwnerId);
          }}
        >
          <Form.Input name="name" label="Name" fluid required />
          <AccountOwnerSelector
            name="accountOwnerId"
            label="Billing Contact"
            required
            hideError
            accountOwnerId={accountOwner?.id}
            showDescriptionBelow
            description={
              "By assigning another user as the Billing contact, " +
              "you will no longer have access to manage the billing information."
            }
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button content="Cancel" basic onClick={onClose} disabled={loading} />
        <Button
          primary
          content="Save"
          type="submit"
          form="editPractice"
          loading={loading}
          disabled={
            !(formProps.formState.isValid && formProps.formState.isDirty) ||
            loading
          }
        />
      </Modal.Footer>
    </Modal>
  );
}

EditPracticeModal.propTypes = {
  practice: PropTypes.shape({ id: PropTypes.string, name: PropTypes.string }),
  accountOwner: PropTypes.shape({ id: PropTypes.string }),
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
};

EditPracticeModal.defaultProps = {
  practice: {},
  accountOwner: {},
  onSubmit: () => {},
  onClose: () => {},
};

export default EditPracticeModal;
